import styled, { css } from 'styled-components';

var TallSeparator = styled.hr.withConfig({
  displayName: "styles__TallSeparator",
  componentId: "sc-1h9nxop-0"
})(["display:block;width:100%;margin:0;height:", "px;border:none;border-top:1px solid ", ";border-bottom:1px solid ", ";background:", ";", ";"], function (props) {
  return props.separatorHeight;
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.backgroundColor;
}, function (props) {
  return css(["margin-top:", "px;margin-bottom:", "px;"], props.verticalMargin, props.verticalMargin);
});
var Border = styled.hr.withConfig({
  displayName: "styles__Border",
  componentId: "sc-1h9nxop-1"
})(["display:block;width:100%;margin:0;border:none;height:1px;background:", ";"], function (props) {
  return props.backgroundColor;
});
var InsetBorderContainer = styled.div.withConfig({
  displayName: "styles__InsetBorderContainer",
  componentId: "sc-1h9nxop-2"
})(["width:100%;padding-left:", "px;", ";"], function (props) {
  return props.inset;
}, function (props) {
  return css(["margin-top:", "px;margin-bottom:", "px;"], props.verticalMargin, props.verticalMargin);
});

export { Border, InsetBorderContainer, TallSeparator };
